import { call, put, select } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import formatDate from 'date-fns/format';

import { deleteNotificationsInCurrentDeviceService } from './notifications';

import {
  fetchSiteRequest,
  fetchDiagramRequest,
  fetchDailyReportsRequest,
  fetchMonthlyReportsRequest,
  fetchYearlyReportsRequest,
  fetchAlertsOccurRequest,
  fetchAlertsResRequest,
  fetchDeviceRequest,
  fetchInvoicesElectricityRequest,
  fetchInvoicesWaterRequest,
  fetchInvoicesGasRequest,
  fetchSettingPricesRequest,
  fetchRealtimeDatasRequest,
  fetchArchitectureRequest,
  fetchSettingEmailsRequest,
} from '../requests';

import {
  currentSiteSelector,
  isCoreInitializingSelector,
  pathsMatchSelector,
  factoriesSelector,
} from '../../../selectors';
import Paths from '../../../constants/Paths';

export function* goToRootService() {
  yield put(push(Paths.ROOT));
}

export function* goToDiagramsService() {
  yield put(push(Paths.DIAGRAM));
}

export function* goToModelsService() {
  yield put(push(Paths.LIST_MODELS));
}

export function* goToProtocolsService() {
  yield put(push(Paths.LIST_PROTOCOLS));
}

export function* goToItemsService() {
  yield put(push(Paths.LIST_ITEMS));
}

export function* goToAlertsSettingService() {
  yield put(push(Paths.LIST_ALERTS_SETTING));
}

export function* goToChannelsService() {
  yield put(push(Paths.LIST_CHANNELS));
}

export function* goToFactoryService(factoryId) {
  yield put(push(Paths.FACTORIES.replace(':id', factoryId)));
}

export function* goToSiteService(siteId) {
  yield put(push(Paths.SITES.replace(':id', siteId)));
}

export function* goToDeviceService(deviceId) {
  yield put(push(Paths.DEVICES.replace(':id', deviceId)));
}

export function* runPathActionsService(pathsMatch) {
  if (!pathsMatch) {
    return;
  }

  switch (pathsMatch.path) {
    case Paths.SITES:
    case Paths.DEVICES: {
      const currentSite = yield select(currentSiteSelector); // TODO: move to services

      if (currentSite && currentSite.isFetching === null) {
        yield call(fetchSiteRequest, currentSite.id);
      }

      if (pathsMatch.path === Paths.DEVICES) {
        yield call(fetchDeviceRequest, pathsMatch.params.id);
        yield call(deleteNotificationsInCurrentDeviceService);
      }

      break;
    }
    case Paths.DIAGRAM: {
      const factories = yield select(factoriesSelector);
      if (factories.length > 0 && factories[0].id) {
        yield call(fetchDiagramRequest, factories[0].id);
      }
      break;
    }
    case Paths.REPORTS:
    case Paths.CHARTS: {
      const currentDay = formatDate(new Date(), 'yyyyMMdd');
      const currentMonth = formatDate(new Date(), 'yyyyMM');
      const currentYear = formatDate(new Date(), 'yyyy');
      const selectedInterval = [];
      selectedInterval.current = 60;
      yield call(fetchDailyReportsRequest, currentDay, selectedInterval);
      yield call(fetchMonthlyReportsRequest, currentMonth);
      yield call(fetchYearlyReportsRequest, currentYear);
      break;
    }
    case Paths.SETTING_INVOICES: {
      yield call(fetchSettingPricesRequest, 'electricity-price');
      yield call(fetchSettingPricesRequest, 'water-price');
      yield call(fetchSettingPricesRequest, 'gas-price');

      const currentMonth = formatDate(new Date(), 'yyyyMM');
      yield call(fetchInvoicesElectricityRequest, currentMonth);
      yield call(fetchInvoicesWaterRequest, currentMonth);
      yield call(fetchInvoicesGasRequest, currentMonth);
      break;
    }
    case Paths.SETTING_PRICES: {
      yield call(fetchSettingPricesRequest, 'electricity-price');
      yield call(fetchSettingPricesRequest, 'water-price');
      yield call(fetchSettingPricesRequest, 'gas-price');
      break;
    }
    case Paths.SETTING_EMAILS: {
      yield call(fetchSettingEmailsRequest);
      break;
    }
    case Paths.LIST_ALERTS: {
      yield call(fetchAlertsOccurRequest);
      yield call(fetchAlertsResRequest);
      break;
    }
    case Paths.REPORT_DEVICE: {
      yield call(fetchRealtimeDatasRequest);
      break;
    }
    case Paths.ARCHITECTURE: {
      const factories = yield select(factoriesSelector);
      if (factories.length > 0 && factories[0].id) {
        yield call(fetchArchitectureRequest, factories[0].id);
      }
      break;
    }
    default:
  }
}

export function* locationChangedService() {
  const pathsMatch = yield select(pathsMatchSelector);

  if (pathsMatch) {
    switch (pathsMatch.path) {
      case Paths.LOGIN:
        yield call(goToRootService);

        break;
      default:
    }
  }

  const isCoreInitializing = yield select(isCoreInitializingSelector);

  if (!isCoreInitializing) {
    yield call(runPathActionsService, pathsMatch);
  }
}
